<div class="container-fluid">
  <footer class="footer">
    <div class="row align-items-center justify-content-xl-between">
      <div class="col-xl-6">
        <div class="copyright text-center text-xl-left text-muted">
          &copy; {{ date | date: "yyyy" }}
          <a
            href="https://www.limitlesscare.com/"
            class="font-weight-bold ml-1"
            target="_blank"
          >
            Limitless Care Portal
          </a>
        </div>
      </div>
    </div>
  </footer>
</div>
